import { render, staticRenderFns } from "./modifytime.vue?vue&type=template&id=45997b22"
import script from "./modifytime.vue?vue&type=script&lang=js"
export * from "./modifytime.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports